import AddIcon from '@mui/icons-material/Add';
import { ButtonGroup } from '@mui/material';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { Button } from 'shared/mui/Buttons';

type Props = {
  onAddGroupClick: () => void;
  onAddExpressionClick: () => void;
  children?: React.ReactNode;
};

export function GatewayRulesFormRuleGroupActions({
  onAddGroupClick,
  onAddExpressionClick,
  children,
}: Props): JSX.Element {
  const translate = useTypedTranslate();

  return (
    <>
      <ButtonGroup variant="outlined">
        <Button
          label={translate('app.gatewayRules.expression')}
          onClick={onAddExpressionClick}
          startIcon={<AddIcon />}
        />
        <Button
          label={translate('app.gatewayRules.group')}
          onClick={onAddGroupClick}
          startIcon={<AddIcon />}
        />
      </ButtonGroup>
      {children}
    </>
  );
}
